import { render, staticRenderFns } from "./tab_list.vue?vue&type=template&id=878d5788&scoped=true"
import script from "./tab_list.vue?vue&type=script&lang=js"
export * from "./tab_list.vue?vue&type=script&lang=js"
import style0 from "./tab_list.vue?vue&type=style&index=0&id=878d5788&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878d5788",
  null
  
)

export default component.exports